export function formatWhen(iso: string | null, locale: string): string {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString(locale)
  } catch {
    return iso
  }
}

export function formatDelta(pct: number | null | undefined): string {
  if (pct == null || Number.isNaN(pct)) return '—'
  const sign = pct > 0 ? '+' : ''
  return `${sign}${pct.toFixed(1)}%`
}

export function deltaClass(pct: number | null | undefined): string {
  if (pct == null || pct === 0) return 'vc-admin-delta--flat'
  return pct > 0 ? 'vc-admin-delta--up' : 'vc-admin-delta--down'
}

export function sparklinePath(
  points: Array<{ count: number }>,
  width = 120,
  height = 36,
): string {
  if (!points.length) return ''
  const values = points.map((p) => p.count)
  const max = Math.max(...values, 1)
  const min = Math.min(...values, 0)
  const range = max - min || 1
  const step = points.length > 1 ? width / (points.length - 1) : width
  return points
    .map((point, index) => {
      const x = index * step
      const y = height - ((point.count - min) / range) * (height - 4) - 2
      return `${index === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')
}

export function exportCsv(filename: string, headers: string[], rows: Array<Array<string | number>>) {
  const escape = (value: string | number) => {
    const text = String(value ?? '')
    if (text.includes(',') || text.includes('"') || text.includes('\n')) {
      return `"${text.replace(/"/g, '""')}"`
    }
    return text
  }
  const lines = [headers.map(escape).join(','), ...rows.map((row) => row.map(escape).join(','))]
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
